export default __webpack_public_path__ + "static/media/flo-spicy.5db1632f.png";